import { SkillImportance, SkillsFramework } from "PFTypes/skills_framework";

import { SkillsFrameworkData } from "./skills_frameworks.types";

export const getFormattedSkillsFramework = (skillsFramework: SkillsFramework) => {
  const groupedCustomFields = skillsFramework.customFields.reduce(
    (acc: SkillsFrameworkData["customFields"], currentCustomField) => {
      const { customType, customValue } = currentCustomField;
      const customFieldIndex = acc.findIndex((customField) => customField.customTypeId === customType.id);

      if (customFieldIndex < 0) {
        return [...acc, { customTypeId: customType.id, customType, values: [customValue] }];
      } else {
        const newList = [...acc];
        newList[customFieldIndex].values.push(customValue);
        return newList;
      }
    },
    []
  );

  const initialSkills = skillsFramework.skills.map(({ importance, experience, customValue }) => ({
    importance,
    experience,
    skill: customValue
  }));

  return {
    ...skillsFramework,
    description: skillsFramework.description || "",
    customFields: groupedCustomFields,
    skills: {
      essential: initialSkills.filter(({ importance }) => importance === SkillImportance.Essential),
      supporting: initialSkills.filter(({ importance }) => importance === SkillImportance.Supporting)
    }
  };
};
